import { alpha, MenuItem, MenuItemProps } from '@mui/material';
import { forwardRef, ReactNode } from 'react';

type Props = Omit<MenuItemProps, 'value'> & {
  grouped?: boolean;
  value?: unknown;
  children?: ReactNode;
};

export const QcsDropdownMenuItem = forwardRef<HTMLLIElement, Props>(
  ({ grouped, sx, value, children, ...rest }, ref) => (
    <MenuItem
      ref={ref}
      {...rest}
      value={value as MenuItemProps['value']}
      sx={[
        {
          pl: grouped ? 3 : 2,
          '&.Mui-selected': {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
            color: 'primary.main',
            '&:hover': {
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.18),
            },
            '&.Mui-focusVisible': {
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.18),
            },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </MenuItem>
  ),
);

QcsDropdownMenuItem.displayName = 'QcsDropdownMenuItem';
